<template>
<div class="container-fluid login" id="login">
  <div class="col-sm-offset-3 col-md-offset-4 col-xs-12 col-sm-6 col-md-4 h100">
    <div class="form-holder">
      <div class="form-holder-inner">
        <div class="form-header">
          <h1><img src='~./../static/img/circles.png' class="logo"/>Radius</h1>
        </div>
        <form @submit.prevent="login">
          <div class="input-holder"
               v-bind:class="{focus: username.length > 0, 'input-holder': true}">
            <input type="text"
                   v-model="username"
                   @keydown="hideError"
                   ref="username" />
            <label>Username</label>
            <span class="line"></span>
          </div>
          <div v-bind:class="{focus: password.length > 0, 'input-holder': true}" class="password">
            <input type="password"
                   v-model="password"
                   @keydown="hideError"
                   ref="password" />
            <label>Password</label>
            <span class="line"></span>
          </div>
          <div class="input-holder"
               v-loading="loading">
            <el-tooltip placement="top"
                        transition="fade-in-linear"
                        visible-arrow="true"
                        :manual="true"
                        v-model="showError">
              <div slot="content"
                   v-html="error"></div>
              <input type="submit"
                     value="LOG IN"
                     v-bind:class="{loading: loading}" />
            </el-tooltip>
          </div>
          <a class="forgot" @click="resetPassword">Forgot Password</a>
        </form>
      </div>
      <div class="login-bg"></div>
    </div>
  </div>
</div>

</template>

<script>
import '../static/js/particles';

export default {
  name: 'Login',
  data() {
    return {
      loading: false,
      username: this.$store.state.user.username || '',
      password: '',
      showError: false,
      error: '',
      timeout: null
    }
  },
  mounted() {
    this.error = this.$store.state.user.error
    this.showError = this.error && this.error.length > 0 ? true : false

    if (!this.username || this.username.length === 0) {
      this.$refs.username.focus()
    } else {
      this.$refs.password.focus()
    }

    particlesJS('login', {
      'particles': {
        'number': {
          'value': 100,
          'density': {
            'enable': true,
            'value_area': 800
          }
        },
        'color': {
          'value': '#ffffff'
        },
        'shape': {
          'type': 'circle',
          'stroke': {
            'width': 0,
            'color': '#000000'
          },
          'polygon': {
            'nb_sides': 4
          },
          'image': {
            'src': 'img/github.svg',
            'width': 100,
            'height': 100
          }
        },
        'opacity': {
          'value': 0.8,
          'random': false,
          'anim': {
            'enable': false,
            'speed': 1,
            'opacity_min': 0.1,
            'sync': false
          }
        },
        'size': {
          'value': 0,
          'random': true,
          'anim': {
            'enable': false,
            'speed': 10,
            'size_min': 0.1,
            'sync': false
          }
        },
        'line_linked': {
          'enable': true,
          'distance': 120,
          'color': '#ffffff',
          'opacity': 0.6,
          'width': 1
        },
        'move': {
          'enable': true,
          'speed': 3,
          'direction': 'none',
          'random': true,
          'straight': false,
          'out_mode': 'out',
          'bounce': false,
          'attract': {
            'enable': false,
            'rotateX': 600,
            'rotateY': 1200
          }
        }
      },
      'interactivity': {
        'detect_on': 'canvas',
        'events': {
          'onhover': {
            'enable': false,
            'mode': 'bubble'
          },
          'onclick': {
            'enable': true,
            'mode': 'push'
          },
          'resize': true
        },
        'modes': {
          'grab': {
            'distance': 400,
            'line_linked': {
              'opacity': 1
            }
          },
          'bubble': {
            'distance': 400,
            'size': 40,
            'duration': 2,
            'opacity': 8,
            'speed': 3
          },
          'repulse': {
            'distance': 200,
            'duration': 0.4
          },
          'push': {
            'particles_nb': 4
          },
          'remove': {
            'particles_nb': 2
          }
        }
      },
      'retina_detect': true
    })
  },
  beforeDestroy() {
    if (window.pJSDom instanceof Array && window.pJSDom.length > 0) {
      for (let i = 0; window.pJSDom && i < window.pJSDom.length; i++) {
        window.pJSDom[i].pJS.fn.vendors.destroypJS()
      }
      window.pJSDom = []
    }
  },
  watch: {
    showError(newVal, oldVal) {
      // Clear error after a short period of time
      if (!oldVal && newVal) {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.showError = false
        }, 3000)
      }
    }
  },
  methods: {
    login() {
      if (this.loading) {
        return
      }

      this.toggleLoading(true)
      this.showError = false

      this.$store.dispatch('login', {
        username: this.username,
        password: this.password,
        callback: (error) => {
          this.toggleLoading(false)
          this.error = error
          this.showError = true
          this.password = ''
          this.$refs.password.focus()
        }
      })
    },
    resetPassword() {
      if (this.loading) {
        return
      }

      if (!this.username) {
        this.showError = true
        this.error = 'Please provide a username'
        return
      }

      this.showError = false
      this.toggleLoading(true)

      let resetPasswordApi = this.$store.getters.baseEndpoint + 'affiliate/' + this.username + '/forget-password'

      this.$http.get(resetPasswordApi)
        .then((response) => {
          this.showError = true
          this.toggleLoading(false)
          this.error = 'A password reset email has been sent'
        })
        .catch((error) => {
          this.showError = true
          this.toggleLoading(false)
          if (this.$http.isApiError(error)) {
            this.error = error.response.data._meta.errors.join(', ')
          }
        })
    },
    toggleLoading(state) {
      this.loading = state
    },
    hideError() {
      this.showError = false
    }
  }
};

</script>

<style lang="scss" scoped="">
@import url('https://fonts.googleapis.com/css?family=Fjalla+One');
.h100 {
  height: 100%;
}

.logo {
  width: 96px;
  margin-right: -68px;
  position: absolute;
  z-index: -1;
  left: -78px;
  top: 26px;
}

.full {
  width: 100%;
}

.row>div {
  box-sizing: border-box;
}

.container-fluid {
  height: 100%;
  min-height: 525px;
  background: linear-gradient(230deg, rgb(75, 207, 147), rgb(75, 121, 207), #22539D) 0% 0% / 150% 150%;
  background-size: 150% 150%;
  -webkit-animation: GradientBG 30s ease infinite;
  -moz-animation: GradientBG 30s ease infinite;
  -o-animation: GradientBG 30s ease infinite;
  animation: GradientBG 30s ease infinite;
}

.form-holder {
  /*FORM HOLDER*/
  z-index: 10;
  font-family: 'Helvetica Neue', Arial;
  width: 285px;
  margin: 0px auto 0 auto;
  position: relative;
  box-shadow: 0px 0px 5px 1px #0e5356;
  border-radius: 3px;
  top: 20%;
  &:after {
    content: '';
    display: block;
    clear: both;
  }
  .el-tooltip,
  .el-tooltip__rel {
    width: 100%;
  }
  @media only screen and (max-height: 600px) {
    top: 10%;
  }
  .login-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #fff;
    border-radius: 3px;
    opacity: 0.7;
  }
  .form-header {
    padding: 0px 0 35px 0;
    position: relative;
  }
  h1 {
    font-family: 'Fjalla One';
    font-size: 45px;
    text-shadow: 0px 0px 2px #eee;
    text-align: center;
    z-index: 5;
    text-transform: uppercase;
    letter-spacing: 3px;
    color: #292136;
    padding-top: 60px;
  }
  .logo {
    font-size: 28px;
    font-family: 'Fjalla One';
    position: absolute;
    bottom: 8px;
    left: 28px;
    text-transform: uppercase;
    letter-spacing: 3px;
    color: #696969;
  }
  .form-holder-inner {
    padding: 0 35px 15px 35px;
    position: relative;
    z-index: 10;
  }
  .input-holder {
    position: relative;
    width: 100%;
    display: block;
    clear: both;
    padding: 20px 0 20px 0;
    &.password {
      padding-bottom: 35px;
    }
    &:last-child {
      padding-top: 30px;
    }
    .line {
      width: 100%;
      height: 1px;
      left: 0;
      border-top: 1px solid #1b566d;
      position: absolute;
      transition: width .3s;
      &:after {
        content: '';
        width: 0%;
        height: 1px;
        left: 0;
        bottom: -1px;
        border-top: 3px solid #F43A4A;
        position: absolute;
        transition: width .3s;
        z-index: 1;
      }
    }
  }
  label {
    font-family: 'Helvetica Neue';
    display: inline-block;
    font-size: 11px;
    position: absolute;
    top: 25px;
    transition: top .3s;
    color: #292136;
    text-transform: uppercase;
  }
  input[type="text"],
  input[type="password"] {
    display: block;
    width: 100%;
    background: transparent;
    border-bottom: none;
    border-left: none;
    border-right: none;
    border-top: none;
    position: relative;
    z-index: 10;
    font-size: 16px;
    padding: 0 0 6px 0;
    outline: none;
    color: #292136;
    &:focus+label+.line:after {
      width: 100% !important;
    }
    &:focus+label {
      top: 0 !important;
    }
  }
  input[type="submit"] {
    outline: none;
    margin: -5px auto 8px auto;
    background: #F43A4A;
    display: block;
    border: none;
    width: 100%;
    padding: 9px 0;
    border-radius: 50px;
    color: white;
    font-size: 14px;
    font-family: 'Raleway', Arial;
    letter-spacing: 4px;
    transition: background .3s, width .3s;
    border: 2px solid #fff;
    box-shadow: 0 0 0 3px #F43A4A;
    -webkit-appearance: none;
    &:not(.loading) {
      cursor: pointer;
    }
    &,
    &:hover:not(.loading) {
      background: #E13546;
      box-shadow: 0 0 0 3px #E13546;
      width: 90%;
    }
  }
  .forgot {
    color: #333;
    font-size: 11px;
    text-align: center;
    display: block;
    position: relative;
    top: -15px;

    &:hover {
      text-decoration: underline;
      cursor: pointer;
    }
  }
  .focus {
    .line:after {
      width: 100% !important;
    }
    label {
      top: 0 !important;
    }
  }
}

.login {
  /*LOGIN*/
  .el-loading-mask {
    background: none !important;
    height: 38px;
    top: 25px;
  }
  .el-loading-spinner .path {
    stroke: #fff !important;
  }
  .el-loading-spinner .circular {
    height: 30px !important;
    margin-top: 6px !important;
  }
}

input.loading {
  text-indent: -1000px;
}

@keyframes GradientBG {
  0% {
    background-position: 0% 84%
  }
  50% {
    background-position: 100% 16%
  }
  100% {
    background-position: 0% 84%
  }
}
</style>



// WEBPACK FOOTER //
// login.vue?29aa7624